import { defineStore } from 'pinia'
import axios from 'axios'

const authEndpoint = process.env.VUE_APP_API_BASE + '/auth';
//const profileEndpoint = process.env.VUE_APP_API_BASE + '/admin/profile';

export const useAuthStore = defineStore({
    id: 'auth',
    state: () => ({
        // initialize state from local storage to enable user to stay logged in
        //user: JSON.parse(localStorage.getItem('user')),
        token: localStorage.getItem('token'),
        refresh_token: localStorage.getItem('refresh_token'),
        role: localStorage.getItem('role'),
        returnUrl: null
    }),
    actions: {
        /*
        _persistUserData() {
            localStorage.setItem('user', JSON.stringify(this.user))
        },
        */
        _persistTokenData() {
            localStorage.setItem('token', this.token)
            localStorage.setItem('refresh_token', this.refresh_token)
            localStorage.setItem('role', this.role)
        },
        /*
        _clearUserData() {
            localStorage.removeItem('user');
        },
        */
        _clearTokenData() {
            localStorage.removeItem('token');
            localStorage.removeItem('refresh_token');
            localStorage.removeItem('role');
        },
        _setAuthData(token, refreshToken, role) {
            this.token = token
            this.refresh_token = refreshToken
            if (role !== undefined) {
                this.role = role
            }
            this._persistTokenData()
        },
        authenticateUser(username, password) {
            const data = {
              email: username,
              password: password,
              isAdmin: true
            }
            return axios.post(authEndpoint + '/login', data)
                .then(response => {
                    if (response.data['success'] == true) {
                        this._setAuthData(response.data['data']['token'],
                              response.data['data']['refresh_token'],
                              response.data['data']['role'])
                    }
                    if (response.data['success'] == false) {
                        alert(response.data['data'])
                    }
                    return response.data['success']
                }).catch(error => {
                    console.log(error)
                    alert('Error occurred. #002')
                    return false
                })
        },
        async refreshToken() {
            //console.log('attempting token refresh')
            try {
                let config = {
                    headers: {
                        'x-device': 'admin',
                        'x-version': '0.0.0.0'
                    }
                }
                const response = await axios.post(authEndpoint + '/refresh-token', {
                    'refresh_token': this.refresh_token
                }, config)

                if (response.data['success'] === true) {
                    this._setAuthData(response.data['data']['token'],
                            response.data['data']['refresh_token'])
                    return true
                }
                else {
                    return false
                }
            }
            catch (error) {
                console.log(error)
                return false
            }
        },
        logout() {
            this.token = null
            this.refresh_token = null
            this._clearTokenData()
        }
    }
});
